import type { Meta, StoryObj } from "@storybook/react";

import { Text } from "@/ui/core";
import { Box, RadialGradientBackground, VStack } from "@/ui/layout";
import type { RadialGradientBackgroundProps } from "@/ui/layout/RadialGradientBackground";

const StoryMeta: Meta<RadialGradientBackgroundProps> = {
  title: "Layout/Radial Gradient Background",
  component: RadialGradientBackground,
  argTypes: {
    variant: {
      control: "select",
      options: ["standard", "subtle"],
    },
  },
  args: {
    variant: "standard",
  },
};

type Story = StoryObj<RadialGradientBackgroundProps>;

const Standard: Story = {
  render: (args) => {
    return (
      <Box width="100%">
        <RadialGradientBackground testID="storybook" variant={args.variant}>
          <VStack alignItems="center" paddingVertical={200}>
            <Text testID="storybook_body" variant="body">
              Radial gradient background
            </Text>
          </VStack>
        </RadialGradientBackground>
      </Box>
    );
  },
};

const Subtle: Story = {
  ...Standard,
  args: { variant: "subtle" },
};

export { Standard, Subtle };
export default StoryMeta;
